import React, { useState, useEffect } from 'react';
import { MapPin, Building2, Home, Download, Send, Edit, Trash2, Plus, Search, FileText, Globe, Filter, PlusCircle, Eye, X, Upload, Image, CheckCircle } from 'lucide-react';
import apiService from '../config';
import { useLanguage } from '../StoreContext/LanguageContext';
import { useRef } from "react";
import { useSignature } from '../DigitalSignature/UseSignatue';
import SignaturePad from '../DigitalSignature/SignaturePad';

const SideBarSection3A = ({ setSubComponent, setSelectedComponent, onBack }) => {
    const [currentProjectId, setCurrentProjectId] = useState(null);
    const [currentProposalId, setCurrentProposalId] = useState(null);
    const [currentProjectName, setCurrentProjectName] = useState(null);
    const [proposalData, setProposalData] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const { language, translations } = useLanguage();
    const [showPrathmik, setShowPrathmik] = useState(false);

    // Modal states
    const [showViewModal, setShowViewModal] = useState(false);
    const [showSendToDSLRModal, setShowSendToDSLRModal] = useState(false);
    const [showPublishModal, setShowPublishModal] = useState(false);
    const [showSendToCoordinationModal, setShowSendToCoordinationModal] = useState(false);

    const ROLES = {
        COLLECTOR: 1,
        LAO: 3,
        SAMANVAY: 6,
        PROJECT_INCHARGE: 18,
        DATA_ENTRY: 14
    };

    const userData = JSON.parse(localStorage.getItem('userData'));
    const userRole = parseInt(userData?.data?.user_role || userData?.user_role, 10);

    const handleSection3Click = () => {
        if (!currentProjectId || !currentProposalId) {
            alert("Project or Proposal ID missing");
            return;
        }

        // 🔥 SET FOR NEXT SCREENS
        localStorage.setItem("currentProjectId", currentProjectId);
        localStorage.setItem("currentProposalId", currentProposalId);

        setSubComponent("SubSection3A");
    };
    useEffect(() => {
        // ---------- PROJECT ----------
        const projectData =
            JSON.parse(localStorage.getItem("currentProjectData")) ||
            JSON.parse(localStorage.getItem("selectedProject")) ||
            JSON.parse(localStorage.getItem("userData"));

        const projectId =
            projectData?.project_id ||
            projectData?.data?.project_id ||
            projectData?.id;

        const projectName =
            projectData?.project_name ||
            projectData?.data?.project_name ||
            projectData?.name;

        // ---------- PROPOSAL ----------
        const proposalData =
            JSON.parse(localStorage.getItem("selectedProposal")) ||
            JSON.parse(localStorage.getItem("userData"));

        const proposalId =
            proposalData?.acquisition_proposal_id ||
            proposalData?.proposal_id ||
            proposalData?.data?.default_proposal ||
            proposalData?.data?.proposal_id;

        setCurrentProjectId(projectId);
        setCurrentProjectName(projectName);
        setCurrentProposalId(proposalId);

        console.log("✅ ProjectId:", projectId);
        console.log("✅ ProposalId:", proposalId);

        setLoading(false);
    }, []);

    // Project Id
    // useEffect(() => {
    //     const getProjectInfo = () => {
    //         const currentProjectData = localStorage.getItem('currentProjectData');
    //         if (currentProjectData) {
    //             try {
    //                 const projectData = JSON.parse(currentProjectData);
    //                 return {
    //                     id: projectData.project_id || projectData.id,
    //                     name: projectData.project_name || projectData.name
    //                 };
    //             } catch (e) {
    //                 console.error('Error parsing current project data (currentProjectData):', e);
    //             }
    //         }

    //         const selectedProject = localStorage.getItem('selectedProject');
    //         if (selectedProject) {
    //             try {
    //                 const project = JSON.parse(selectedProject);
    //                 return {
    //                     id: project.project_id || project.id,
    //                     name: project.project_name || project.name
    //                 };
    //             } catch (e) {
    //                 console.error('Error parsing selected project (selectedProject):', e);
    //             }
    //         }

    //         const userData = localStorage.getItem('userData');
    //         if (userData) {
    //             try {
    //                 const user = JSON.parse(userData);
    //                 const projectId = user.data?.project_id || user.project_id;
    //                 const projectName = user.data?.project_name || user.project_name || 'Unknown Project';
    //                 return {
    //                     id: projectId,
    //                     name: projectName
    //                 };
    //             } catch (e) {
    //                 console.error('Error parsing user data (userData):', e);
    //             }
    //         }
    //         return { id: null, name: null };
    //     };

    //     const projectInfo = getProjectInfo();
    //     setCurrentProjectId(projectInfo.id);
    //     setCurrentProjectName(projectInfo.name);
    //     console.log('Current Project Info:', projectInfo);
    // }, []);

    // Proposal id
    // useEffect(() => {
    //     const getProposalInfo = () => {
    //         const currentProposal = JSON.parse(localStorage.getItem('userData') || '{}');

    //         if (currentProposal) {
    //             try {
    //                 return {
    //                     proposalId: currentProposal?.data?.default_proposal ||
    //                         currentProposal?.data?.proposal_id ||
    //                         currentProposal?.default_proposal ||
    //                         currentProposal?.proposal_id ||
    //                         null
    //                 }
    //             } catch (e) {
    //                 console.error('Error parsing current project data (getProposalInfo):', e);
    //             }
    //         }
    //         return { proposalId: null };
    //     };

    //     const proposalInfo = getProposalInfo();
    //     setCurrentProposalId(proposalInfo.proposalId);
    //     console.log('Current Project-Proposal Info:', proposalInfo);
    // }, []);

    if (loading) {
        return (
            <div className="p-6 max-w-7xl mx-auto">
                <div className="flex justify-center items-center h-80">
                    <div className="text-center animate-float">
                        <div className="inline-flex relative">
                            <div className="w-16 h-16 rounded-full border-4 border-slate-700 border-t-transparent animate-spin"></div>
                            <div className="w-16 h-16 rounded-full border-4 border-purple-500 border-b-transparent border-r-transparent animate-spin absolute inset-0" style={{ animationDuration: '1.5s', animationDirection: 'reverse' }}></div>
                            <div className="absolute inset-0 flex items-center justify-center">
                                <FileText className="h-6 w-6 text-purple-400 animate-pulse" />
                            </div>
                        </div>
                        <p className="text-gray-400 mt-4">{translations[language]?.LoadingProposalData}</p>
                    </div>
                </div>
            </div>
        );
    }

    if (error) {
        return (
            <div className="bg-red-50 border border-red-200 rounded-lg p-4">
                <div className="flex items-center">
                    <div className="text-red-600 mr-3">⚠️</div>
                    <div>
                        <p className="text-red-600">{error}</p>
                    </div>
                </div>
            </div>
        );
    }

    return (
        <div className="bg-gray-50 min-h-screen">
            <div className="max-w-7xl mx-auto">
                {/* Header */}
                <div className="bg-white rounded-lg shadow-sm p-6 mb-6">
                    <div className="flex justify-between items-center">

                        {/* Buttons */}
                        <button
                            onClick={handleSection3Click}
                            className="px-5 py-3 text-sm bg-gradient-to-r from-blue-600 to-blue-700
             hover:from-blue-700 hover:to-blue-800 text-white rounded-xl"
                        >
                            {translations[language].section3A}
                        </button>

                    </div>
                </div>
            </div>


        </div>
    );
};

export default SideBarSection3A;